import { Component, OnInit, Renderer2, Inject, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { OrdersService, MaterialData } from '../../data/orders.service';
import { Material } from '../../../vendor/data/material';
import { Order } from '../../data/order';
import { Project } from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import { Vendor } from '../../../vendor/data/vendor';
import { OrderItem } from '../../data/order-item';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VendorsService } from '../../../vendor/data/vendors.service';
import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { Subject, Subscription, timer } from 'rxjs';
import { MaterialsService } from '../../../vendor/data/materials.service';
import { Listbox } from 'primeng/listbox';
import { debounceTime } from 'rxjs/operators';
import { CvMaterial } from '../../data/cv-material';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';


@Component({
  selector: 'app-order-modal',
  templateUrl: './order-modal.component.html',
  styleUrls: ['./order-modal.component.scss']
})
export class OrderModalComponent implements OnInit, OnDestroy {
  escEventListener = null;

  shortProjects: ShortProject[];
  selectedShortProj: ShortProject;

  vendors: Vendor[];
  selectedVendor: Vendor;

  allMaterials: Material[];
  projectMaterials: Material[];
  selectedMaterials: Material[] = [];
  selectedMaterialIds: number[] = [];

  projectMaterialLimits: number[] = [];

  projectItems: OrderItem[];
  order: Order;
  tempOrder: Order;

  temporaryId: number;

  temporaryProject: Project;

  temporaryVendor: Vendor;

  temporaryItems: OrderItem[];

  loadingSpinner = false;
  projectsLoading: boolean;

  buttonLabel: string;

  showMaterials: boolean;

  @ViewChild('listBox')
  listBoxCmp: Listbox

  searchSubj = new Subject<string>()
  getMaterialsSub: Subscription

  orderNotes: string;

  constructor(
    private snackBar: MatSnackBar,
    protected dialog: MatDialog,
    protected ordersService: OrdersService,
    protected materialsService: MaterialsService,
    protected dialogRef: MatDialogRef<OrderModalComponent>,
    protected el: ElementRef,
    protected vendorsService: VendorsService,
    protected renderer: Renderer2,
    @Inject(MAT_DIALOG_DATA) public data: { order: Order, buttonLabel: string, projectId: number }
  ) {
    this.order = data.order
    this.buttonLabel = data.buttonLabel;
  }

  ngOnInit() {
    this.escEventListener = (event: KeyboardEvent) => {
      const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+
      if(key === 'Escape') {
        this.dialog.closeAll();
      }

    }

    document.addEventListener('keydown', this.escEventListener);

    if(this.order) {
      this.temporaryId = this.order.id;
      this.temporaryItems = this.order.items;

      this.tempOrder = Object.assign({}, this.order)
      this.orderNotes = this.tempOrder.notes ? this.tempOrder.notes : ''

      if(this.tempOrder.expectedDeliveryDate) {
        this.tempOrder.expectedDeliveryDate = new Date(this.tempOrder.expectedDeliveryDate)
      }
    }

    this.getVendors();
    this.getProjects();
  }

  getVendors() {
    this.vendorsService.getVendors().subscribe(vendors => {
      this.vendors = vendors;
      if(this.order) {
        if(this.order.vendor) {
          this.selectedVendor = this.vendors.find(ven => ven.id === this.order.vendor.id)
        }
      } else {
        this.selectedVendor = this.vendors[0]
      }
    })

  }

  getProjects() {
    this.projectsLoading = true;
    this.ordersService.getProjectsForNewOrders().subscribe(projs => {
      this.shortProjects = projs;

      if(this.order) {
        if(this.order.project) {
          this.selectedShortProj = this.shortProjects.find(proj => proj.id === this.order.project.id)
          if(!this.selectedShortProj) {
            this.shortProjects.unshift(this.order.project)
            this.selectedShortProj = this.order.project
          }
        }
      }
      if(!this.selectedShortProj && this.data.projectId) {
        this.selectedShortProj = this.shortProjects.find(proj => proj.id === this.data.projectId)
      }

      if(this.selectedShortProj) {
        this.getMaterials(this.selectedShortProj.id);
      }

      this.projectsLoading = false;
      // this.selectedProj
    })
  }

  projectIsChoosen() {
    this.showMaterials = false;
    this.selectedMaterials = [];

    this.getMaterials(this.selectedShortProj.id);
  }

  getMaterials(projectId: number) {
    this.ordersService.getMaterials(projectId).subscribe(mats => {
      this.projectMaterials = mats;


      if(this.tempOrder && this.projectMaterials.length > 0 && this.tempOrder.project.id === projectId) {
        this.tempOrder.items.forEach(item => {
          const fItem = this.projectMaterials.find(mat => mat.cvMaterialId === item.cvMaterial.id);

          if(fItem) {
            this.selectedMaterials.push(fItem)
            this.selectedMaterialIds.push(fItem.cvMaterialId)
            fItem.orderedQuantity = item.orderedQuantity
          }
        })
      } else {
        this.selectedMaterials = [];
      }


      if(this.buttonLabel === 'Accept' || this.buttonLabel === 'Confirm') {
        this.projectMaterials = [...this.selectedMaterials];

        this.projectMaterials.forEach(mat => {
          this.projectMaterialLimits.push(mat.orderedQuantity)
        })

      }

      this.showMaterials = true;

      if(this.buttonLabel === 'Create' || this.buttonLabel === 'Save') {
        this.dropDownIsShown();
      }
    })
  }

  fillSelectedMaterialsFromCvMaterials() {
    this.selectedMaterials = []

    this.selectedMaterialIds.forEach(matId => {
      const fItem = this.projectMaterials.find(mat => mat.cvMaterialId === matId);

      if(fItem) {
        this.selectedMaterials.push(fItem)
      }
    })
  }

  dropDownIsShown() {
    const elems = (this.el.nativeElement as HTMLElement).getElementsByClassName('p-list-box-block');
    this.allMaterials = [...this.projectMaterials];

    this.listBoxCmp.onFilter = () => {
    }

    this.searchSubj.pipe(debounceTime(250)).subscribe(val => {
      this.getMaterialsSub = this.materialsService.searchShortMaterialsForOrders(0, 100, val).subscribe(cvMats => {

        this.projectMaterials = cvMats.map(cvMat => {
          return {
            id: cvMat.id,
            name: cvMat.name,
            cvMaterialId: cvMat.id
          } as Material
        })

        this.fillSelectedMaterialsFromCvMaterials()
      })

    })


    timer(1).subscribe(emit => {
      const inputs = elems[0].getElementsByClassName('p-inputtext');

      inputs[0].addEventListener('keyup', e => {
        const keyBoardEvent = e as KeyboardEvent
        const val = (inputs[0] as HTMLInputElement).value.toLowerCase();
        if(val) {
          if(keyBoardEvent.key !== 'Alt' && keyBoardEvent.key !== 'Shift') {
            this.searchSubj.next(val)
          }
        } else {
          this.projectMaterials = this.allMaterials

          this.fillSelectedMaterialsFromCvMaterials();

          if(this.getMaterialsSub) {
            this.getMaterialsSub.unsubscribe()
          }
        }

      });
    })
  }

  onListboxChange(event) {
    const clickedMaterial = event.option as Material

    let foundedIndex = -1;

    const foundedMaterialId = this.selectedMaterialIds.find((matId, index) => {
      if(matId === clickedMaterial.cvMaterialId) {
        foundedIndex = index
        return matId
      }
    })

    if(foundedMaterialId >= 0) {
      this.selectedMaterialIds.splice(foundedIndex, 1)
    } else {
      this.selectedMaterialIds.unshift(clickedMaterial.cvMaterialId)
    }

    if(this.allMaterials && !this.allMaterials.find(matFromAll => matFromAll.cvMaterialId === clickedMaterial.cvMaterialId)) {
      this.allMaterials.unshift(clickedMaterial)
    }

  }

  saveOrder() {
    this.loadingSpinner = true;
    const materialData = [] as MaterialData[];

    if(this.tempOrder && this.tempOrder.items) {
      delete this.tempOrder.items;
    }

    if(this.buttonLabel === 'Create') {
      // 			this.selectedMaterials = this.allMaterials.filter(allmat => this.selectedMaterialIds.includes(allmat.cvMaterialId))
    }

    this.selectedMaterials.forEach(mat => {
      const matData = {
        cvMaterialId: mat.cvMaterialId,
      } as MaterialData;

      if(this.buttonLabel === 'Accept' || this.buttonLabel === 'Confirm') {
        matData.count = mat.orderedQuantity;
        matData.backorder = mat.backorder;
      }

      materialData.push(matData)
    })

    if(this.buttonLabel === 'Create') {
      this.ordersService.newOrder(this.selectedShortProj.id, this.selectedVendor.id, materialData, this.orderNotes).subscribe(order => {
        this.dialogRef.close(order);
      }, error => {
        this.loadingSpinner = false;
        this.openSnackBar(error.message)
      })
    }

    if(this.buttonLabel === 'Save') {

      this.tempOrder.project = this.selectedShortProj;
      this.tempOrder.vendor = this.selectedVendor;

      this.tempOrder.materialIds = this.selectedMaterialIds

      this.tempOrder.notes = this.orderNotes

      this.ordersService.updateOrder(this.tempOrder).subscribe(order => {
        this.dialogRef.close(order);
      }, error => {
        this.loadingSpinner = false;
        this.openSnackBar(error.message)
      })
    }

    if(this.buttonLabel === 'Accept') {
      this.ordersService.acceptDelivery(this.order.id, materialData, this.orderNotes).subscribe(order => {
        this.dialogRef.close(order);
      }, error => {
        this.loadingSpinner = false;
        this.openSnackBar(error.message)
      })
    }

    if(this.buttonLabel === 'Confirm') {
      if(typeof this.tempOrder.expectedDeliveryDate === 'undefined') {
        this.tempOrder.expectedDeliveryDate = null
      }

      this.ordersService.confirmOrder(this.order.id, materialData, this.tempOrder.expectedDeliveryDate, this.orderNotes).subscribe(order => {
        this.dialogRef.close(order);
      }, error => {
        this.loadingSpinner = false;
        this.openSnackBar(error.message)
      })
    }

  }

  openSnackBar(message: string) {
    this.snackBar.open(message, '', {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  countPlus(matId: number) {
    if(this.projectMaterials[matId].orderedQuantity < this.projectMaterialLimits[matId]) {
      this.projectMaterials[matId].orderedQuantity++;
    }
  }

  countMinus(matId: number) {
    if(this.projectMaterials[matId].orderedQuantity > 0) {
      this.projectMaterials[matId].orderedQuantity--;
    }
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  changePhoto() {

  }

  ngOnDestroy(): void {
    this.searchSubj.unsubscribe()
    document.removeEventListener('keydown', this.escEventListener);
  }

  blurActiveElement() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      if (activeElement && activeElement instanceof HTMLElement)
        activeElement.blur()
    }, 5);
  }


}
